import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=3dbc64a9&scoped=true"
import script from "./ReportCard.vue?vue&type=script&lang=ts"
export * from "./ReportCard.vue?vue&type=script&lang=ts"
import style0 from "./ReportCard.vue?vue&type=style&index=0&id=3dbc64a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbc64a9",
  null
  
)

export default component.exports